import type { JSX } from 'react';

import { useWork } from '../api/work.ts';
import { Card } from '../ui/Card.tsx';
import { Loaded } from '../ui/Loaded.tsx';
import { WorkLog } from './WorkLog.tsx';

/** Every session that paid something off, newest first. */
export function WorkHistory(): JSX.Element {
  const work = useWork();

  return (
    <Card title="Work logged" description="Minutes counted against a balance, newest first.">
      <Loaded
        query={work}
        loading="Loading your work…"
        error="Your work could not be loaded. Please reload the page."
      >
        {({ recent }) => <WorkLog sessions={recent} />}
      </Loaded>
    </Card>
  );
}
